export function formatArticleLink(cleanTitle) {
  return `/stories/${cleanTitle}`
}

export default { formatArticleLink }
